import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import '../../assets/saas/molecules/_popover.scss';
const PopoverComponent = ({ isVisible, onClose, anchorEl, children }) => {
    const popoverRef = useRef(null);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    // Función para verificar si un elemento está en el viewport
    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= window.innerHeight &&
            rect.right <= window.innerWidth);
    };
    useEffect(() => {
        if (anchorEl && isVisible) {
            const rect = anchorEl.getBoundingClientRect();
            let newPosition = {
                top: rect.bottom + window.scrollY - 25,
                left: rect.left + window.scrollX + 15 + rect.width / 2,
            };
            if (popoverRef.current) {
                const popoverWidth = popoverRef.current.offsetWidth || 300; // fallback width
                const viewportWidth = window.innerWidth;
                if (newPosition.left + popoverWidth > viewportWidth) {
                    const leftPosition = rect.left + window.scrollX - 15 - popoverWidth + rect.width / 2;
                    if (leftPosition > 0) {
                        newPosition.left = leftPosition;
                    }
                    else {
                        newPosition.left = viewportWidth - popoverWidth - 10;
                    }
                }
            }
            setPosition(newPosition);
        }
    }, [anchorEl, isVisible]);
    // Cerrar el popover cuando el ancla sale del viewport durante el scroll
    useEffect(() => {
        if (!isVisible || !anchorEl)
            return;
        const handleScroll = () => {
            if (anchorEl && !isElementInViewport(anchorEl)) {
                onClose();
            }
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isVisible, onClose, anchorEl]);
    useEffect(() => {
        if (!isVisible)
            return;
        const handleClickOutside = (event) => {
            if (popoverRef.current &&
                !popoverRef.current.contains(event.target) &&
                anchorEl !== event.target &&
                !(anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.contains(event.target))) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isVisible, onClose, anchorEl]);
    if (!isVisible)
        return null;
    const popoverContent = (_jsxs("div", { className: "popover-component", ref: popoverRef, style: {
            position: 'absolute',
            top: `${position.top}px`,
            left: `${position.left}px`,
        }, children: [_jsx("div", { className: "popover-content" }), children] }));
    return ReactDOM.createPortal(popoverContent, document.body);
};
export default PopoverComponent;
